import script from "./Cards.vue?vue&type=script&setup=true&lang=js"
export * from "./Cards.vue?vue&type=script&setup=true&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=6ef85b60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef85b60"]])

export default __exports__